module.exports = __webpack_public_path__ + "img/central_plaza.png";